<app-spinner></app-spinner>

<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
  <mat-card style="padding: 1px; margin-top: 10px;">
    <!-- <div *ngIf="fshown.file"> 
        <p class="Bread" >Repo</p>
        </div> -->
    <mat-tab-group>
      <div class="olabel">
        <mat-tab class="topmenu" style="margin-top: 4px;" label="OCR Template">
          <ul style="padding-left: 2px;">
            <mat-card-header *ngIf="fshown.folder" style="height: 50px;">
              <div
                class="btn2"
                style="
                  margin-top: 4px;
                  cursor: pointer;
                  display: block;
                  float: left;
                "
                (click)="openDialog()"
              >
                <img
                  src="assets/img/icons/group-22.png "
                  matTooltip="Add"
                  matTooltipPosition="left"
                />
              </div>
            </mat-card-header>

            <mat-card-header *ngIf="fshown.file" style="height: 40px;">
              <!-- <div class="Bread" (click)="backToTemplate()" >home</div>
                         <div class="Bread">{{folderName}}</div> -->

              <div class="breadcrumb flat">
                <a [ngClass]="{ active: true }" (click)="backToTemplate()">
                  <span class="editable">{{ folderName }}</span>
                </a>
              </div>
            </mat-card-header>

            <div *ngIf="fshown.folder">
              <div
                style="padding: 0px;"
                *ngFor="let repo of RepositoryData"
                class="box col-md-3 col-sm-3 col-xs-3 col-lg-3"
              >
                <img
                  style="padding: 40px; cursor: pointer;"
                  src="assets/img/icons/layer-60.png "
                  (click)="fileView(repo)"
                />
                <div class="repo">{{ repo }}</div>
              </div>
            </div>

            <div *ngIf="fshown.file">
              <div
                style="padding: 0px;"
                *ngFor="let file of fileList"
                class="box col-md-3 col-sm-3 col-xs-3 col-lg-3"
              >
                <img
                  style="padding: 40px; cursor: pointer;"
                  src="assets/img/icons/layer-60.png "
                />

                <div class="repo">
                  {{ file.fileName }}
                </div>
                <div
                  class="repo"
                  (click)="onView(file.fileId)"
                  matTooltip="view"
                  matTooltipPosition="below"
                >
                  <mat-icon style="cursor: pointer; font-size: 24px;">
                    visibility</mat-icon
                  >
                </div>
              </div>
            </div>
          </ul>
        </mat-tab>
        <!-- <ul>
          <mat-tab class="tlable" label="Email Account" class="activePage">
          </mat-tab>
        </ul> -->
      </div>
    </mat-tab-group>
  </mat-card>
</div>
